// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2kvEa","clinicsSelect":"TableHeading_clinicsSelect__15EbY"};